import { type ErrorCodeMap } from './types';

export const authErrorCodes: ErrorCodeMap = {
  AUTH_NOT_AUTHENTICATED: 'desktop.errors.auth.notAuthenticated',
  AUTH_TOKEN_REQUEST_FAILED: 'desktop.errors.auth.tokenFailed',
  AUTH_REFRESH_UNAVAILABLE: 'desktop.errors.auth.refreshUnavailable',
  AUTH_ATTEMPT_EXPIRED: 'desktop.errors.auth.attemptExpired',
  AUTH_ATTEMPT_PENDING: 'desktop.errors.auth.attemptPending',
  AUTH_BROWSER_LAUNCH_FAILED: 'desktop.errors.auth.browserFailed',
  AUTH_KEYCHAIN_ERROR: 'desktop.errors.auth.keychainError',
  AUTH_NETWORK_ERROR: 'desktop.errors.auth.networkError',
  AUTH_CALLBACK_INVALID: 'desktop.errors.auth.callbackInvalid',
  AUTH_CALLBACK_MISSING_PARAM: 'desktop.errors.auth.callbackMissingParam',
  AUTH_CALLBACK_NO_ATTEMPT: 'desktop.errors.auth.callbackNoAttempt',
  AUTH_CALLBACK_REPLAY: 'desktop.errors.auth.callbackReplay',
  AUTH_STATE_MISMATCH: 'desktop.errors.auth.stateMismatch',
  AUTH_PROVIDER_ERROR: 'desktop.errors.auth.providerError',
  AUTH_CONFIG_ERROR: 'desktop.errors.auth.configError',
  AUTH_CONFIG_VALIDATION: 'desktop.errors.auth.configValidation',
  AUTH_NOT_IMPLEMENTED: 'desktop.errors.auth.notImplemented',
  AUTH_LOCAL_CREDENTIAL_STORE_ERROR: 'desktop.errors.auth.keychainError',
  AUTH_REFRESH_SUPERSEDED: 'desktop.errors.auth.refreshUnavailable',
};
